import { createFileRoute } from "@tanstack/react-router";

import { AppLayout } from "@/presentation/layouts/AppLayout";
import { ExportPage } from "../pages/ExportPage";

interface ExportSearch {
  site?: string;
}

export const Route = createFileRoute("/export")({
  component: function ExportRouteComponent() {
    const search = Route.useSearch();
    return (
      <AppLayout>
        <ExportPage siteId={search.site} />
      </AppLayout>
    );
  },
  validateSearch: (search: Record<string, unknown>): ExportSearch => {
    return {
      site: search.site as string | undefined,
    };
  },
});
